<script lang="ts" setup>
import { Button, ButtonVariant } from '../../Button';
import { ButtonGroup } from '../../ButtonGroup';
import { Link, LinkFontSize } from '../../Link';
import { ToastAction } from '../types';

defineProps<{
  title?: string;
  message?: string;
  action?: ToastAction;
}>();

defineEmits<{
  close: [];
}>();
</script>

<template>
  <div class="ml-3 w-0 flex-1 pt-0.5">
    <p
      v-if="title"
      data-test="toast-title"
      class="text-sm font-medium text-slate-900 mb-1"
    >
      {{ title }}
    </p>

    <p
      v-if="message"
      data-test="toast-message"
      class="text-sm text-slate-500"
    >
      {{ message }}
    </p>

    <div
      v-if="action"
      class="mt-3"
    >
      <ButtonGroup>
        <Button
          plain
          :variant="ButtonVariant.Critical"
          @click="$emit('close')"
        >
          Cancel
        </Button>
        <Link
          underline
          :font-size="LinkFontSize.Small"
          :href="action.url"
        >
          {{ action.label }}
        </Link>
      </ButtonGroup>
    </div>
  </div>
</template>
